import script from "./AdminTrainingView.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminTrainingView.vue?vue&type=script&setup=true&lang=js"

import "./AdminTrainingView.vue?vue&type=style&index=0&id=78172450&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78172450"]])

export default __exports__